export const environment = {
  production: false,
  apiGatewayUrl: 'https://gatewayapi-dev.academy.inclub.world', //  'http://localhost:8080', // 
  backofficeUrl: 'https://dev.inclub.world/backoffice/login-nuevo',
};
